module.exports = __webpack_public_path__ + "img/63.6b20c636.png";